export let mixins = {
    data() {
        return {
            videoElement: null,
            MP_VIDEO_DOCUMENT: null,
            instance: null,
            source: '', // 视频地址
            playerId: "aliplayer_" +
                Math.random().toString(36).substr(2), // 视频video id
            playStyle: {}, // 视频video样式
            aliplayerSdkPath: '//g.alicdn.com/de/prismplayer/2.9.3/aliplayer-min.js', // Aliplayer 代码的路径
            width: '100%',
            height: '500px',
            isLive: false, // 是否为直播
            autoplay: false, // 是否自动播放
            playsinline: false, // H5是否内置播放，有的Android浏览器不起作用。
            format: '', // 指定播放地址格式 (mp4, hls或m3u8, flv, mp3)
            controlBarVisibility: 'always', // 控制面板的实现，
            useH5Prism: false, // 指定使用H5播放器
            useFlashPrism: false, // 指定使用Flash播放器
            playauth: '', // 播放权证，获取播放权重请参见获取音视频播放凭证
            disableSeek: true,
            vid: '',
            cover: '',
            x5_video_position: '',
            x5_type: '',
            x5_fullscreen: '',
            x5_orientation: '',
            autoPlayDelay: '',
            autoPlayDelayDisplayText: '',
            isPlay: false, // 开关（是否开启保存视频学习进度）

            isFullScreen: false, // 是否开启全屏
        }
    },
    methods: {
        insertScriptTag() { // 加载 ali视频播放器js
            const _this = this
            let playerScriptTag = document.getElementById('playerScriptTag')
            // 如果这个tag不存在，则生成相关代码tag以加载代码
            if (playerScriptTag === null) {
                playerScriptTag = document.createElement('script')
                playerScriptTag.type = 'text/javascript'
                playerScriptTag.src = this.aliplayerSdkPath
                playerScriptTag.id = 'playerScriptTag'
                let s = document.getElementsByTagName('head')[0]
                s.appendChild(playerScriptTag)
            }

            if (!playerScriptTag.loaded) {
                playerScriptTag.addEventListener('load', () => {
                    _this.scriptTagStatus++
                    playerScriptTag.loaded = true
                    _this.initAliplayer()
                })
            }

            _this.initAliplayer()
        },
        initAliplayer() {
            const _this = this

            // scriptTagStatus 为 2 的时候，说明两个必需引入的 js 文件都已经被引入，且加载完成
            if (_this.instance === null && window.Aliplayer) {
                // Vue 异步执行 DOM 更新，这样一来代码执行到这里的时候可能 template 里面的 script 标签还没真正创建
                // 所以，我们只能在 nextTick 里面初始化 Aliplayer
                _this.$nextTick(async () => {
                    _this.instance = window.Aliplayer({
                        id: _this.playerId,
                        autoplay: _this.autoplay,
                        isLive: _this.isLive,
                        playsinline: _this.playsinline,
                        format: _this.format,
                        width: _this.width,
                        height: _this.height,
                        controlBarVisibility: _this.controlBarVisibility,
                        useH5Prism: _this.useH5Prism,
                        useFlashPrism: _this.useFlashPrism,
                        diagnosisButtonVisible: false,
                        skinLayout: [
                            {
                                name: "H5Loading", align: "cc"
                            },
                            {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
                            {name: "infoDisplay"},
                            {name: "thumbnail"},
                            {
                                name: "controlBar", align: "blabs", x: 0, y: 0,
                                children: [
                                    {name: "progress", align: "blabs", x: 0, y: 44},
                                    {name: "playButton", align: "tl", x: 15, y: 12},
                                    {name: "timeDisplay", align: "tl", x: 10, y: 7},
                                    {name: "fullScreenButton", align: "tr", x: 10, y: 12},
                                    {name: "volume", align: "tr", x: 5, y: 10}
                                ]
                            }
                        ],
                        vid: _this.vid,
                        playauth: _this.playauth,
                        source: _this.source,
                        cover: _this.cover,
                        x5_video_position: _this.x5_video_position,
                        x5_type: _this.x5_type,
                        x5_fullscreen: _this.x5_fullscreen,
                        x5_orientation: _this.x5_orientation,
                        autoPlayDelay: _this.autoPlayDelay,
                        autoPlayDelayDisplayText: _this.autoPlayDelayDisplayText
                    })
                    // 获取video节点
                    this.videoElement = document.getElementsByTagName('video')[0]
                    this.videoElement.id = 'mediaElementID'; // 设置id
                    this.MP_VIDEO_DOCUMENT = document.getElementById("mediaElementID");

                    if(this.videoHost && this.videoHost.code === 200) {
                        this.MP_VIDEO_DOCUMENT.currentTime = this.videoHost.data.studyTime ? this.videoHost.data.studyTime : 0; // 设置播放时长
                        this.videoInfoIsPlay = true
                    } else {
                        this.$alert(this.videoHost && this.videoHost.msg, '课程提示', {
                            showConfirmButton: true
                        });
                        this.videoInfoIsPlay = false
                    }
                    // 获取进度条节点
                    let prismProgress = document.getElementsByClassName('prism-controlbar')
                    document.getElementsByClassName('prism-progress-cursor')[0].remove()

                    let divElement = document.createElement("div")
                    divElement.setAttribute("style", "position: absolute;z-index: 60;width: 100%;height: 6px;top:0")
                    divElement.setAttribute("id", "positionZ")
                    prismProgress[0].appendChild(divElement)

                    // 绑定事件，当 AliPlayer 初始化完成后，将编辑器实例通过自定义的 ready 事件交出去
                    _this.instance.on('ready', () => {
                        // this.$emit('ready', _this.instance)
                    })

                    _this.instance.on('play', () => {
                        if(!this.videoInfoIsPlay)  {
                            _this.instance.pause()
                            return false;
                        }

                        // 如果播放完成就暂停，禁止播放
                        if (this.videoHost && this.videoHost.isComplete === '1') {
                            _this.instance.pause()
                            _this.$alert('当前小节，播放完成，请勿重新观看', '小节提示', {
                                confirmButtonText: '确定',
                            })
                        }

                        // 点击播放判断是否需要进行拍照
                        this.canPhotoStart()

                        // this.$emit('play', _this.instance)
                        this.isPlay = true
                    })

                    _this.instance.on('pause', () => {
                        if(!this.videoInfoIsPlay) return false;
                        this.isPlay = false

                        //  暂停定时器停止
                        clearInterval(_this.timeupdateTimer) // 保存接口暂停
                        _this.timeupdateTimer = null

                        //  记录当前学习时间
                        if(_this.isSavePcSection)
                        _this.savePcSection(_this.currentSectionId, _this.instance.getCurrentTime())
                    })

                    _this.instance.on('ended', () => {
                        // this.$emit('ended', _this.instance)
                        // 自动播放完成后
                        this.canPhotoEnd()

                        // 自动播放完成后，开启下一节跳转
                        _this.showVideoTip = true

                        //  记录当前学习时间
                        _this.savePcSection(_this.currentSectionId, _this.instance.getCurrentTime())

                        _this.nextSection = _this.getSectionNext(this.sectionList,this.currentSectionId , 'next')

                    //    自动退出全屏, 判断是否全屏
                        if(this.isFullScreen) {
                            setTimeout(() => {
                                document.exitFullscreen()
                                this.isFullScreen = false
                            }, 500)
                        }
                        _this.isVideoEnd = true
                        _this.isMaskShow = '0'
                    })

                    _this.instance.on('liveStreamStop', () => {
                        // this.$emit('liveStreamStop', _this.instance)
                    })

                    _this.instance.on('liveStreamStop', () => {
                        // this.$emit('liveStreamStop', _this.instance)
                    })

                    _this.instance.on('m3u8Retry', () => {
                        // this.$emit('m3u8Retry', _this.instance)
                    })

                    _this.instance.on('hideBar', () => {
                        // this.$emit('hideBar', _this.instance)
                    })

                    _this.instance.on('waiting', () => {
                        // this.$emit('waiting', _this.instance)
                    })

                    _this.instance.on('snapshoted', () => {
                        // this.$emit('snapshoted', _this.instance)
                    })

                    _this.instance.on('requestFullScreen', (e) => {
                        // this.$emit('snapshoted', _this.instance)
                        this.isFullScreen = true
                    })

                    _this.instance.on('cancelFullScreen', (e) => {
                        // this.$emit('snapshoted', _this.instance)
                        this.isFullScreen = false
                    })


                    _this.instance.on('timeupdate', () => {
                        if(!this.videoInfoIsPlay) return false;
                        // this.$emit('snapshoted', _this.instance)
                        // 记录当前时间
                        _this.videoCurrentTime = _this.instance.getCurrentTime()
                        // 开启定时器进行学习保存
                        if (this.isPlay) {
                            _this.setIntervalFn()
                        }

                        if(_this.autoVideoPlay === '1') {
                            sessionStorage.setItem('isAutoVideoPlay', '0')
                            _this.autoplay = false
                        }
                    })

                })
            }
        }
    }
}